export const EXPORT_OPTION_LABEL = 'Export options:';
export const SELECT_CONTENT_FOR_EXPORT = 'Select content for export';
export const EXPORT_SHOULD_INCLUDE = 'Export should include';
export const EXPORT_BUTTON_LABEL = 'Export';
export const LOADING_EXPORT_BUTTON_LABEL = 'Export...';
export const QUERY_DESCRIPTION_LABEL = 'Query description';
export const PLOT_LABEL = 'Plot';
export const TABLE_LABEL = 'Table';
export const COLUMN_SETTINGS_LABEL = 'Apply column settings';
